export default {
  'pages.login.rememberMe': '自动登录',
  'pages.login.forgotPassword': '忘记密码 ?',
  'pages.welcome.alertMessage': '更快更强的重型组件，已经发布。',
  'pages.admin.subPage.title': ' 这个页面只有 admin 权限才能查看',
  delete: '删除',
  edit: '修改',
  cancel: '取消',
  clear: '清除',
  new: '新建',
  update: '更新',
  undo: '撤销',
  option: '选项',
  details: '详情',
  deleting: '删除中',
  createdAt: '创建时间',
  firstSeen: '首次出现',
  lastActive: '最后活跃',
  'idle.title': '您的会话即将过期',
  'idle.content': '立即恢复会话或退出登录',
  resume: '恢复',
  name: '名称',
  'success.reloading': '成功，正在重新加载页面',
  'fail.retry': '失败，请重试',
  tags: '标签',
  after: '之后',
  flow: '流程',
  text: '文本',
  image: '图片',
  video: '视频',
  file: '文件',
  custom: '自定义',
  input: '输入',
  quickReplies: '快捷回复',
  ctaUrl: 'CTA 链接',
  button: '按钮',
  question: '问题',
  fieldRequired: '此字段为必填项',
  entity: '实体',
  active: '活跃',
  inactive: '不活跃',
  deleted: '已删除',
  next: '下一步',
  category: '类别',
  portalUser: '门户用户',
  role: '角色',
  admin: '管理员',
  user: '用户',
  username: '用户名',
  email: '电子邮件',
  firstName: '名',
  lastName: '姓',
  fullName: '全名',
  resetPassword: '重置密码',
  'resetPassword.emailSent': '密码重置邮件已发送给该用户',
  'resetPassword.confirm.title': '确定要重置此用户的密码吗？',
  'resetPassword.confirm.content': '密码重置邮件将发送至 {username} ({email})',
  'resetPassword.emailFailed': '发送重置邮件失败，请重试',
  'resetPassword.tokenExpired': '重置密码令牌已过期',
  oldPassword: '当前密码',
  newPassword: '新密码',
  'password.characterNotMet': '密码必须包含至少一个字母、一个数字和一个特殊字符',
  confirmPassword: '确认密码',
  'confirmPassword.mismatch': '两次输入的密码不一致！',
  unlock: '解锁',
  'portalUser.unlock.title': '解锁该用户',
  'portalUser.unlock.content': '{username}（{email}）——如适用，密码重置邮件将发送给该用户',
  'portalUser.userPasswordModal.title': '用户密码窗口',
  logout: '退出登录',
  dormant: '休眠',
  'portalUser.dormant.title': '确定要将此用户设为休眠吗？',
  'portalUser.dormant.content': '{username}（{email}）——请注意，休眠后该用户将无法再访问此门户',
  reactivate: '重新激活',
  'portalUser.reactivate.title': '确定要重新激活此用户吗？',
  'portalUser.reactivate.content':
    '{username}（{email}）——请注意，重新激活后该用户将立即恢复访问此门户的权限',
  'portalUser.delete.title': '确定要删除此用户吗？',
  'portalUser.delete.content':
    '{username}（{email}）——请注意，删除后该用户将无法再访问此门户。个人数据将被清除，您也可以选择将该用户设为休眠状态。',
  'portalUser.delete.undo': '{username}（{email}）已删除',
  'portalUser.emailChange.title': '更改用户电子邮件？',
  'portalUser.emailChange.content':
    '电子邮件将更新为 {newEmail}，并向该地址发送密码重置邮件。该用户将被登出，必须设置新密码才能再次登录。',
  'portalUser.emailChange.noEmail.content':
    '电子邮件将更新为 {newEmail}。该机构未配置邮件服务，因此将生成一个新密码并显示给您，以便分享给该用户。',
  platform: '平台',
  notes: '备注',
  'pages.review.title': '审查',
  'pages.review.description': '根据您的问题清单，对一份或多份文档生成结构化审查',
  'pages.file.placeholder.type': '类型',
  'pages.file.placeholder.people': '创建者',
  'pages.file.placeholder.search': '搜索文件或文件夹',
  'pages.file.placeholder.editfile': '修改文件名',
  'pages.file.pdf': 'PDF',
  'pages.file.document': '文档',
  'pages.file.msg': 'MSG',
  'pages.file.eml': 'EML',
  'pages.file.txt': '文本',
  'pages.file.md': 'Markdown',
  'pages.file.excel': 'Excel',
  'pages.file.powerpoint': 'PowerPoint',
  'pages.file.uploading': '上传中',
  'pages.file.clickDragFile': '点击或拖动文件到此处上传',
  'pages.file.createfolder': '新建文件夹',
  'pages.file.uploadFiles': '上传文件',
  'pages.file.upload.time': '上传时间：',
  'pages.file.created.time': '创建时间：',
  'pages.file.favorites': '我的收藏',
  'pages.file.history': '修订历史',
  'pages.file.success': '创建成功',
  'pages.file.filePreview': '文件预览',
  'pages.file.prompt.uploadFiled': '上传失败',
  'pages.file.prompt.network': '网络错误',
  'pages.file.prompt.fetchFiles': '获取文件列表信息失败',
  'pages.file.prompt.createGroup': '创建群组失败',
  'pages.file.prompt.createFolderSucc': '文件夹创建成功',
  'pages.file.prompt.createFolderFail': '创建文件夹失败',
  'pages.file.prompt.updateSucc': '更新成功',
  'pages.file.prompt.updateFail': '更新失败',
  'pages.file.prompt.addFavoriteFail': '添加失败',
  'pages.file.prompt.noPermission': '您无权修改此会话',
  'pages.file.prompt.duplicateName': '会话名称重复',
  'pages.file.prompt.notFound': '未找到会话',
  'pages.file.prompt.deleteGroupSuc': '删除成功',
  'pages.file.prompt.uploadFiles': '个文件准备上传',
  'pages.file.prompt.downloadSucc': '下载成功',
  'pages.file.prompt.downloadFail': '下载失败',
  'pages.file.prompt.authFail': '缺少授权令牌。',
  'pages.file.prompt.moveSucc': '文件移动成功',
  'pages.chat.newWithUploadedDocument': '使用文档新建对话',
  'pages.chat.editSessionName': '修改会话名称',
  'pages.chat.placeholder.inputSessionName': '输入新的会话名称',
  'pages.chat.placeholder': '输入您想问的内容...',
  'pages.chat.word': '/10000 字符',
  'pages.chat.rateMessage.successfulLike': '成功点赞该消息',
  'pages.chat.rateMessage.successfulDislike': '成功点踩该消息',
  'pages.chat.actions.like': '回答很好',
  'pages.chat.actions.dislike': '回答不佳',
  'pages.chat.rateMessage.error': '消息评分失败',
  'pages.chat.selectContext.setFilePriority.success': '文件优先级更新成功',
  'pages.chat.selectContext.setFilePriority.error': '更新文件优先级时出错',
  'pages.chat.selectContext.toolTipDefault': '默认情况下，机器人将访问您有权访问的所有文件。',
  'pages.chat.rerank':
    '在返回结果之前对搜索结果进行二次排序。这可能会提高结果质量，但会显著降低搜索速度。',
  'pages.chat.selectContext.tootlTipRestrict': '您可以使用此菜单限制模型可使用的文件。',
  'pages.chat.hybridSearchAlphaTooltip':
    '搜索比例控制语义搜索与关键词搜索之间的平衡。较低的值偏向关键词搜索，较高的值偏向语义搜索。',
  'pages.chat.favoriteFileWeight': '此权重会人为提高收藏文件的搜索排名。',
  'pages.dashboard.realTimeUsersTitleTooltip':
    '当前正在与机器人互动或在过去 5 分钟内与机器人互动过的用户数量。',
  'pages.dashboard.activeUsersTitleTooltip': '在所选时间段内与机器人互动过的用户数量。',
  'pages.dashboard.newUsersTitleTooltip': '在所选时间段内首次与机器人互动的用户数量。',
  'pages.dashboard.promptTokensTitleTooltip': '所选时间段内处理的输入令牌数量。',
  'pages.dashboard.completionTokensTitleTooltip': '所选时间段内生成的输出令牌数量。',
  'pages.dashboard.userMessagesTitleTooltip': '所选时间段内用户发送的消息数量。',
  'pages.dashboard.storyboardsTitleTooltip': '所选时间段内由预建聊天机器人剧本处理的用户消息数量。',
  'pages.dashboard.botMessagesTitleTooltip': '所选时间段内机器人发送给用户的消息数量。',
  'pages.dashboard.broadcastsTitleTooltip':
    '所选时间段内机器人通过广播功能主动发送给用户的消息数量。',
  'pages.dashboard.repliesTitleTooltip': '所选时间段内回复用户消息的数量。',
  'pages.dashboard.messageExchangesTitleTooltip': '所选时间段内用户与机器人交换的消息数量。',
  'pages.dashboard.broadcastTitleTooltip': '所选时间段内机器人发起的广播数量。',
  'pages.dashboard.outReachTitleTooltip': '所选时间段内所有广播的接收人数总和。',
  'pages.chat.stopGenerating': '已停止生成。',
  'pages.chat.stopGenerating.error': '停止生成失败。',
  'pages.app.timeline': '时间线',
  'pages.app.guided_summary': '引导式摘要',
  'pages.app.standard_info': '快速信息',
  'pages.login.microsoftSSO': '使用 Microsoft 登录',
  'pages.login.loading': '加载中...',
  'pages.login.redirectingToMS': '正在跳转至 Microsoft SSO...',
  'pages.loggedOut.title': '已退出登录',
  'pages.loggedOut.heading': '您已退出登录',
  'pages.loggedOut.description': '您可以关闭此窗口，或返回登录页面重新登录。',
  'pages.loggedOut.return': '返回登录',
};
